import React, { useState } from "react";
import { Flex, Link, TextArea, TextField } from "@adobe/react-spectrum";
import styles from "./invoice_comment_section.module.css";
import { useTranslation } from "react-i18next";

interface IInvoiceCommentSection {
  invoice: any;
  isEdit: any;
  onChange: (data: any) => void;
}

const InvoiceCommentSection: React.FC<IInvoiceCommentSection> = ({
  invoice,
  onChange,
}) => {
  const { t } = useTranslation("invoice");
  const _t = (key: string, defaultValue: string) =>
    t(`add_update_invoice.${key}`, { ns: "invoice", defaultValue });
  const _tt = (key: string, defaultValue: string) =>
    t(`invoice_common.${key}`, { ns: "invoice", defaultValue });

  const [showInternalMore, setShowInternalMore] = useState(false);
  const [showClientMore, setShowClientMore] = useState(false);

  const updateField = (field: string, value: string) => {
    onChange({ ...invoice, [field]: value });
  };

  return (
      <Flex marginTop={10} direction={{ base: "column", L: "row" }} gap="size-150" width="100%">
        <Flex direction="column" gap="size-125" UNSAFE_className={styles.panel}>
          <Flex justifyContent="end" UNSAFE_className={styles.toggle_row}>
            <Link
              isQuiet
              UNSAFE_className={styles.show_more_button}
              onPress={() => setShowInternalMore((prev) => !prev)}
            >
              {showInternalMore
                ? _tt("show_less", "Show less")
                : _tt("show_more", "Show more")}
            </Link>
          </Flex>

          {showInternalMore ? (
            <TextArea
              label={_t("notes_for_us", "Notes for us:")}
              width="100%"
              value={invoice?.internalDescription || ""}
              onChange={(v) => updateField("internalDescription", v || "")}
              minHeight="size-1200"
            />
          ) : (
            <TextField
              label={_t("notes_for_us", "Notes for us:")}
              width="100%"
              value={invoice?.internalDescription || ""}
              onChange={(v) => updateField("internalDescription", v || "")}
            />
          )}
        </Flex>

        <Flex direction="column" gap="size-125" UNSAFE_className={styles.panel}>
          <Flex justifyContent="end" UNSAFE_className={styles.toggle_row}>
            <Link
              isQuiet
              UNSAFE_className={styles.show_more_button}
              onPress={() => setShowClientMore((prev) => !prev)}
            >
              {showClientMore
                ? _tt("show_less", "Show less")
                : _tt("show_more", "Show more")}
            </Link>
          </Flex>

          {showClientMore ? (
            <>
              <TextField
                label={_t("header_text", "Header:")}
                width="100%"
                value={invoice?.headerText || ""}
                onChange={(v) => updateField("headerText", v || "")}
              />
              <TextArea
                label={_t("text_above_items_summary", "Text above items (summary):")}
                width="100%"
                value={invoice?.summaryText || ""}
                onChange={(v) => updateField("summaryText", v || "")}
                minHeight="size-900"
              />
              <TextArea
                label={_t(
                  "text_below_items_notes_to_client",
                  "Text below items (notes to client):"
                )}
                width="100%"
                value={invoice?.description || ""}
                onChange={(v) => updateField("description", v || "")}
                minHeight="size-900"
              />
              <TextField
                label={_t("footer_text", "Footer:")}
                width="100%"
                value={invoice?.footerText || ""}
                onChange={(v) => updateField("footerText", v || "")}
              />
            </>
          ) : (
            <TextField
              label={_t("text_above_items_summary", "Text above items (summary):")}
              width="100%"
              value={invoice?.summaryText || ""}
              onChange={(v) => updateField("summaryText", v || "")}
            />
          )}
        </Flex>
      </Flex>
  );
};

export default InvoiceCommentSection;
